import React, { useCallback, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import MonthDropdown from "../../../components/inputs/MonthDropdown";
import YearDropdown from "../../../components/inputs/YearDropdown";
import { InputLabel } from "../../../components/inputs/InputLabel";

import useToastActionWrapper from "../../../hooks/useToastActionWrapper";
import { MONTHS_OPTIONS } from "../../../components/inputs/consts";

const today = new Date();
const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

const initialSelectedPeriod = {
  month: lastMonth.getMonth(),
  year: lastMonth.getFullYear(),
};

export function GenerateAllEmpBillsDialog({
  visible,
  onClose,
  toastRef,
  header,
  buttonLabel,
  buttonIcon,
  action,
  successMessageBuilder,
  errorMessage,
}) {
  const { toastActionWrapper } = useToastActionWrapper(toastRef);

  const [selectedPeriod, setSelectedPeriod] = useState(initialSelectedPeriod);

  const onSubmit = useCallback(async () => {
    const monthName = MONTHS_OPTIONS.find(
      (m) => m.code === selectedPeriod.month
    )?.name;
    await toastActionWrapper({
      action: () =>
        action({
          year: selectedPeriod.year,
          month: selectedPeriod.month,
        }),
      successMessage: successMessageBuilder(monthName, selectedPeriod.year),
      errorMessage,
    });
    onClose();
  }, [selectedPeriod, toastActionWrapper, onClose, action, successMessageBuilder, errorMessage]);

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: "35vw" }}
      onHide={onClose}
    >
      <section className="flex flex-column">
        <div>
          <InputLabel label="Period" required />
          <div className="flex flex-column sm:flex-row gap-2 field">
            <MonthDropdown
              monthIndex={selectedPeriod.month}
              onChange={(option) =>
                setSelectedPeriod((prev) => ({
                  ...prev,
                  month: Number(option.code),
                }))
              }
            />
            <YearDropdown
              year={selectedPeriod.year}
              onChange={(option) =>
                setSelectedPeriod((prev) => ({
                  ...prev,
                  year: Number(option.code),
                }))
              }
            />
          </div>
        </div>

        <Button
          className="w-full sm:w-16rem sm:h-3rem sm:mt-2"
          style={{ alignSelf: "end" }}
          label={buttonLabel}
          icon={buttonIcon}
          onClick={onSubmit}
        />
      </section>
    </Dialog>
  );
}
